



































import {VueperSlides, VueperSlide} from 'vueperslides';
import 'vueperslides/dist/vueperslides.css';

import QuickReserv from '@/components/QuickReserv.vue';
import Component from 'vue-class-component';
import GeneralUtil from '@/util/GeneralUtil';

import boardService from '@/services/board.service';
import {BOARD_ID} from '@/util/BoardConst';
import {Watch} from 'vue-property-decorator';
@Component({
  components: {
    GeneralUtil,
    VueperSlides,
    VueperSlide,
    QuickReserv,
  },
})
export default class MainSlider extends GeneralUtil {
  parallaxFixedContent = true;
  bannerItems: any[] = [];
  bannerItemsMobile: any[] = [];
  isLang = 0;
  isMobile = false;

  @Watch('$i18n.locale')
  localechanged(newVal: string, oldVal: string) {
    this.refreshLocale(newVal);
  }

  refreshLocale(newVal: string) {
    if (newVal === 'ko') {
      this.isLang = 0;
    } else if (newVal === 'en') {
      this.isLang = 1;
    } else if (newVal === 'ja') {
      this.isLang = 2;
    } else {
      this.isLang = 0;
    }
  }

  checkMobile() {
    this.isMobile = window.innerWidth <= 768;
  }

  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  }

  async created() {
    this.refreshLocale(this.$i18n.locale);
    // const aList = await boardService.getArticleList(
    //   BOARD_ID.BID_PODO_MAIN_SLIDER,
    //   1,
    //   100,
    //   'BoardArticleDetailWithFiles',
    //   'sortIdx',
    //   'asc',
    // );
    //
    // this.bannerItems = aList._embedded.boardArticles.map(x => ({
    //   id: x.id,
    //   title: x.title,
    //   desc: x.subtitle1,
    //   src: `${x.attachFiles[0]?.urlPath}${x.attachFiles[0]?.fileName}`,
    // }));
    // this.bannerItemsMobile = aList._embedded.boardArticles.map(x => ({
    //   id: x.id,
    //   title: x.title,
    //   desc: x.subtitle1,
    //   src: `${x.attachFiles[1]?.urlPath ?? x.attachFiles[0]?.urlPath}${
    //     x.attachFiles[1]?.fileName ?? x.attachFiles[0]?.fileName
    //   }`,
    // }));
    const aList = await boardService.getArticleList(
      BOARD_ID.BID_PODO_MAIN_SLIDER,
      1,
      100,
      'BoardArticleDetailWithFiles',
      'sortIdx',
      'asc',
    );

    for (const x of aList._embedded.boardArticles) {
      const files = x.attachFiles;
      if (!files || files.length === 0) continue;

      for (const file of files) {
        const src = `${file.urlPath}${file.fileName}`;
        const image = new Image();
        image.src = src;

        try {
          await image.decode();
        } catch (err) {
          console.warn('이미지 로딩 실패:', src);
          continue;
        }

        const ratio = image.width / image.height;
        const item = {
          id: `${x.id}-${file.fileName}`,
          title: x.title,
          desc: x.subtitle1,
          src,
        };

        if (files.length > 1) {
          if (ratio > 1) {
            this.bannerItems.push(item);
          } else {
            this.bannerItemsMobile.push(item);
          }
        } else {
          this.bannerItems.push(item);
          this.bannerItemsMobile.push(item);
        }
      }
    }
  }
}
